// Préférences d'affichage de la sidebar (blocs masqués + ordre), par utilisateur.
// Enregistrées côté backend pour qu'elles suivent le compte, pas le navigateur.

import { useState, useEffect, useCallback } from "react";
import { fetchSidebarPreferences, saveSidebarPreferences } from "../lib/api";
import { applyTheme } from "../lib/theme";

const EMPTY = {
  hidden: [], order: [], hiddenSets: [], setOrder: [],
  progressEnabled: false, progressExcluded: [],
  theme: "dark", pokedexHome: false,
  avatar: null, // n° national du Pokémon-avatar de la barre du haut
};

export function useSidebarPrefs() {
  const [prefs, setPrefs] = useState(EMPTY);

  useEffect(() => {
    fetchSidebarPreferences()
      .then(p => setPrefs({ ...EMPTY, ...p }))
      .catch(err => console.error("Préférences sidebar :", err));
  }, []);

  // Le thème vit sur <html> (attribut data-theme), pas dans React : c'est du
  // CSS pur. On se contente donc de le poser à chaque changement.
  useEffect(() => { applyTheme(prefs.theme); }, [prefs.theme]);

  // Optimiste : on applique tout de suite à l'écran, on enregistre derrière.
  // En cas d'échec on revient à l'état précédent pour ne pas afficher une
  // configuration qui n'a pas été sauvegardée.
  const savePrefs = useCallback(async (next) => {
    const previous = prefs;
    setPrefs(next);
    try {
      await saveSidebarPreferences(next);
    } catch (err) {
      console.error("Enregistrement des préférences échoué :", err);
      setPrefs(previous);
      throw err;
    }
  }, [prefs]);

  return { prefs, savePrefs };
}
